module.exports = __webpack_public_path__ + "static/media/LTL_package_active.70c90412.svg";